import { IonContent, IonIcon, IonPage, IonText } from "@ionic/react"
import { calendar, chevronDownCircleOutline, cube, documentOutline, logoUsd, person } from "ionicons/icons"
import React, { useEffect, useState } from "react"
import { useHistory } from "react-router"
import service from "../../../Service/service"
import Foot from "../../Footer"
import Head from "../../Header"
import Sidebar from "../../Sidebar"

const HRDashboard: React.FC = () => {
    const history = useHistory();
    const [Id] = useState(localStorage.getItem("SignupEmpId"));
    const [role] = useState(localStorage.getItem("EmpName"))
    useEffect(() => {
        if (Id === null) {
            history.push("/login");
        } else {
        }
    }, [Id, history]);

    const [emp, setEmp] = useState("");
    const [prj, setPrj] = useState("");
    const [todayabsent, settodayabsent] = useState('');
    const [pendingleave, setpendingleave] = useState('');
    const [pendingtimesheet, setpendingtimesheet] = useState('');
    const [misstimesheet, setmisstimesheet] = useState('');
    const [todaybirthday, settodaybirthday] = useState('')
    const [pendingConfirm, setpendingconfirm] = useState('');
    const [confirmdue, setconfirmdue] = useState('');
    const [compoffapproval,setcompoffapproval]=useState('')

    useEffect(() => {
        Dashboardrecords();
    }, []);

    //------------------Dashboard Api----------------//

    const Dashboardrecords = () => {
        service.Dashboard(Id)
            .then((response) => {
                console.log("All Employee", response);
                if (response.status === 200) {
                    setEmp(response.data.employeesCount)
                    setPrj(response.data.projectCount)
                    settodayabsent(response.data.todaysLeave)
                    setpendingleave(response.data.pendingLeaveApprovals)
                    setpendingtimesheet(response.data.pendingTimesheetApprovals)
                    setcompoffapproval(response.data.pendingCompOffApprovals)
                    setmisstimesheet(response.data.missingTimesheets)
                    settodaybirthday(response.data.todaysBirthday)
                    setpendingconfirm(response.data.pendingConfirmation)
                    setconfirmdue(response.data.confirmDue)
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }

    //------------------Navigation-------------------//

    const ViewEmploye = () => {
    
            const userRole = localStorage.getItem("UserRole");
        
            if (userRole === "ADMIN") {
                history.push("./HREmployeeDashboard"); 
            } else if (userRole === "MANAGER" || userRole === "BUSINESS_UNIT_HEAD" || userRole === "DEPARTMENT_HEAD") {
                history.push("./ManagerEmployeDashboard"); 
            } else {
        
            }
        }
    
    const Viewproject = () => {
        history.push("./HRProjectDashboard")
    }
    const ViewLeave = () => {
        history.push("./Leaveapprovalpending")
    }
    const ViewTimesheetApproval = () => {
        history.push("./TPDashboard")
    }
    const ViewMissingTimesheet = () => {
        history.push("./MissingTsDashboard")
    }
    const ViewTodayLeave = () => {
        history.push("./Todaysleave")
    }
    const ViewBirthday = () => {
        history.push("./EmployeesBirthday")
    }
    const ViewPending = () => {
        history.push("./PendingConfirm")
    }
    const ViewCompoff = () => {
        history.push("./PendingCompoff")
    }
    return (
        <IonPage >
            <Head />
            <Sidebar />
            <IonContent >
                <div  className="page-wrapper">
                    <div className="page-header" >
                        <div className="row">
                            <div className="col-sm-12">
                                <h3 className="page-title">Welcome {role} !</h3>
                                <ul className="breadcrumb">
                                    <li className="breadcrumb-item active">Dashboard</li>
                                </ul>
                            </div>
                        </div>
                        <div style={{ paddingTop: '15px' }}>
                            <div className="row">
                                <div className="col-md-6 col-sm-6 col-lg-6 col-xl-3"  onClick={ViewEmploye}>
                                    <div className="card dash-widget">
                                        <div className="card-body"style={{height: '140px',transition: 'background-color 0.3s'}}
                                            onMouseEnter={(e) => (e.currentTarget.style.background = 'linear-gradient(to right, #fff1e1, white)')}
                                            onMouseLeave={(e) => (e.currentTarget.style.background = 'linear-gradient(to right, white, white)')} >
                                            <span className="dash-widget-icon"><i className="fa fa-users" /></span>
                                            <div className="dash-widget-info">
                                                <br></br>
                                                <h3>{emp}</h3>
                                                <span>My Employees</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 col-sm-6 col-lg-6 col-xl-3" onClick={Viewproject} >
                                    <div className="card dash-widget">
                                        <div className="card-body" style={{height: '140px',transition: 'background-color 0.3s'}}
                                            onMouseEnter={(e) => (e.currentTarget.style.background = 'linear-gradient(to right, #fff1e1, white)')}
                                            onMouseLeave={(e) => (e.currentTarget.style.background = 'linear-gradient(to right, white, white)')}>
                                            <span className="dash-widget-icon"><i className="fa fa-cubes" /></span>
                                            <div className="dash-widget-info">
                                                <br></br>
                                                <h3>{prj}</h3>
                                                <span>My Projects & Status</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div className="row">
                                {/* <div className="col-md-6 col-sm-6 col-lg-6 col-xl-3" onClick={ViewTodayLeave}>
                                    <div className="card dash-widget">
                                        <div className="card-body"style={{height: '140px',transition: 'background-color 0.3s'}}
                                            onMouseEnter={(e) => (e.currentTarget.style.background = 'linear-gradient(to right, #fff1e1, white)')}
                                            onMouseLeave={(e) => (e.currentTarget.style.background = 'linear-gradient(to right, white, white)')}>
                                            <span className="dash-widget-icon"><i className="fa fa-address-book-o" /></span>
                                            <div className="dash-widget-info">
                                                <br></br>
                                                <h3>{todayabsent}</h3>
                                                <span>Today's Absentees</span>
                                            </div>
                                        </div>
                                    </div>
                                </div> */}
                                {/* <div className="col-md-6 col-sm-6 col-lg-6 col-xl-3" onClick={ViewLeave}>
                                    <div className="card dash-widget">
                                        <div className="card-body"style={{height: '140px',transition: 'background-color 0.3s'}}
                                            onMouseEnter={(e) => (e.currentTarget.style.background = 'linear-gradient(to right, #fff1e1, white)')}
                                            onMouseLeave={(e) => (e.currentTarget.style.background = 'linear-gradient(to right, white, white)')}>
                                            <span className="dash-widget-icon"><i className="fa fa-list-alt" /></span>
                                            <div className="dash-widget-info">
                                                <br></br>
                                                <h3 style={{ color: 'red' }}>{pendingleave}</h3>
                                                <span>Leave Approval Pending</span>
                                            </div>
                                        </div>
                                    </div>
                                </div> */}
                                <div className="col-md-6 col-sm-6 col-lg-6 col-xl-3" onClick={ViewTimesheetApproval}>
                                    <div className="card dash-widget">
                                        <div className="card-body"style={{height: '140px',transition: 'background-color 0.3s'}}
                                            onMouseEnter={(e) => (e.currentTarget.style.background = 'linear-gradient(to right, #fff1e1, white)')}
                                            onMouseLeave={(e) => (e.currentTarget.style.background = 'linear-gradient(to right, white, white)')}>
                                            <span className="dash-widget-icon"><i className="fa fa-window-close-o" /></span>
                                            <div className="dash-widget-info">
                                                <br></br>
                                                <h3 style={{ color: 'red' }}>{pendingtimesheet}</h3>
                                                <span>TimeSheet Approval Pending</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 col-sm-6 col-lg-6 col-xl-3" onClick={ViewMissingTimesheet}>
                                    <div className="card dash-widget">
                                        <div className="card-body"style={{height: '140px',transition: 'background-color 0.3s'}}
                                            onMouseEnter={(e) => (e.currentTarget.style.background = 'linear-gradient(to right, #fff1e1, white)')}
                                            onMouseLeave={(e) => (e.currentTarget.style.background = 'linear-gradient(to right, white, white)')}>
                                            <span className="dash-widget-icon"><i className="fa fa-braille" /></span>
                                            <div className="dash-widget-info">
                                                <br></br>
                                                <h3 style={{ color: 'red' }}>{misstimesheet}</h3>
                                                <span>Missing Timesheets</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            {/* <div className="col-md-6 col-sm-6 col-lg-6 col-xl-3" onClick={ViewBirthday}>
                                <div className="card dash-widget">
                                    <div className="card-body"style={{height: '140px',transition: 'background-color 0.3s'}}
                                            onMouseEnter={(e) => (e.currentTarget.style.background = 'linear-gradient(to right, #fff1e1, white)')}
                                            onMouseLeave={(e) => (e.currentTarget.style.background = 'linear-gradient(to right, white, white)')}>
                                        <span className="dash-widget-icon"><i className="fa fa-birthday-cake" /></span>
                                        <div className="dash-widget-info">
                                            <br></br>
                                            <h3>{todaybirthday}</h3>
                                            <span>Todays Birthday</span>
                                        </div>
                                    </div>
                                </div>
                            </div> */}
                            {/* <div className="col-md-6 col-sm-6 col-lg-6 col-xl-3" onClick={ViewPending}>
                                <div className="card dash-widget">
                                    <div className="card-body"style={{height: '140px',transition: 'background-color 0.3s'}}
                                            onMouseEnter={(e) => (e.currentTarget.style.background = 'linear-gradient(to right, #fff1e1, white)')}
                                            onMouseLeave={(e) => (e.currentTarget.style.background = 'linear-gradient(to right, white, white)')}>
                                        <span className="dash-widget-icon"><i className="fa fa-product-hunt" /></span>
                                        <span>Upto This month <a style={{ fontWeight: 'bold', fontSize: '25px', color: 'red', marginLeft: '2px' }}>{pendingConfirm}</a>  </span>
                                        <div className="dash-widget-info" style={{ marginTop: '20px' }}>
                                            <span style={{ display: 'inline-block', marginRight: '10px' }}>Next Month</span>
                                            <a style={{ display: 'inline-block', fontWeight: 'bold', fontSize: '20px' }}>{confirmdue}</a>
                                        </div>
                                        <div className="dash-widget-info">
                                            <span>Pending Confirmations</span>
                                        </div>
                                    </div>
                                </div>
                            </div> */}
                            {/* <div className="col-md-6 col-sm-6 col-lg-6 col-xl-3" onClick={ViewCompoff}>
                                    <div className="card dash-widget">
                                        <div className="card-body"style={{height: '140px',transition: 'background-color 0.3s'}}
                                            onMouseEnter={(e) => (e.currentTarget.style.background = 'linear-gradient(to right, #fff1e1, white)')}
                                            onMouseLeave={(e) => (e.currentTarget.style.background = 'linear-gradient(to right, white, white)')}>
                                            <span className="dash-widget-icon"><i className="fa fa-link" /></span>
                                            <div className="dash-widget-info">
                                                <br></br>
                                                <h3 style={{ color: 'red' }}>{compoffapproval}</h3>
                                                <span>Pending Comp-off</span>
                                            </div>
                                        </div>
                                    </div>
                                </div> */}
                        </div>
                    </div>
                </div>
            </IonContent>
        </IonPage>

    )

}

export default HRDashboard